import {
  ChangeDetectionStrategy,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  Input,
  ViewEncapsulation,
} from '@angular/core';

export type SwiperImage = {
  src: string;
  alt?: string;
  title?: string;
  loading?: 'lazy' | 'eager';
};

@Component({
  selector: 'app-image-swiper',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: `
    <swiper-container
      [attr.slides-per-view]="1"
      [attr.loop]="loop ? 'true' : null"
      [attr.centered-slides]="centered ? 'true' : null"
      [attr.pagination]="pagination ? 'true' : null"
      [attr.navigation]="navigation ? 'true' : null"
      [attr.autoplay]="autoplay ? '' : null"
      [attr.autoplay-delay]="autoplayDelay"
      [attr.speed]="speed"
      [attr.space-between]="spaceBetween"
      [attr.keyboard]="keyboard ? 'true' : null"
      [attr.mousewheel]="mousewheel ? 'true' : null"
    >
      @for (img of images; track img.src) {
        <swiper-slide>
          <img
            class="img"
            [src]="img.src"
            [attr.alt]="img.alt ?? ''"
            [attr.title]="img.title ?? null"
            draggable="false"
          />
        </swiper-slide>
      }
    </swiper-container>
  `,
  styleUrls: ['./swiper.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImageSwiperComponent {
  @Input({ required: true }) images: SwiperImage[] = [];

  @Input() loop = true;
  @Input() centered = false;
  @Input() pagination = true;
  @Input() navigation = true;

  @Input() autoplay = false;
  @Input() autoplayDelay = 3000;

  @Input() speed = 400;
  @Input() spaceBetween = 0;

  @Input() keyboard = true;
  @Input() mousewheel = false;
}
